
import React from "react";

export const BuilderIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}
            {...props}>
            <path d="M2 22V13C2 12.45 2.45 12 3 12H7V22" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 14H7" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
            <path d="M3.2 15.5H5.2V17.5H3.2V15.5Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.2 19H5.2V21H3.2V19Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 22V5C7 4.45 7.45 4 8 4H16C16.55 4 17 4.45 17 5V22" stroke="currentColor" strokeWidth="1.5"
                strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 6.5H17" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
            <path d="M9 8H11V10H9V8Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
            <path d="M13 8H15V10H13V8Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
            <path d="M9 11.5H11V13.5H9V11.5Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13 11.5H15V13.5H13V11.5Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 15H11V17H9V15Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
            <path d="M13 15H15V17H13V15Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17 22V13C17 12.45 17.45 12 18 12H22C22.55 12 22 12.45 22 13V22" stroke="currentColor"
                strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17 14H22" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
            <path d="M18.5 15.5H20.5V17.5H18.5V15.5Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.5 19H20.5V21H18.5V19Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1 22H23" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
                strokeLinejoin="round" />
        </svg>
    );
};